import "./loader.css";

const Loader = () => {
  return (
    <div className="relative">
      <div className="flex h-[100vh] items-center justify-center">
        <div className="toaster-container">
          <div className="spinner"></div>
        </div>
      </div>
    </div>
  );
};

export default Loader;
